import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  makeStyles,
  Typography,
  Box,
  Divider
} from "@material-ui/core";
import TagModal from "../TagModal";

const useStyles = makeStyles((theme) => ({
  dialog: {
    "& .MuiDialog-paper": {
      borderRadius: "12px",
      boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
      minWidth: "500px",
      maxWidth: "600px",
    },
  },
  title: {
    fontSize: "1.25rem",
    fontWeight: 600,
    color: theme.palette.primary.main,
    padding: theme.spacing(2, 3, 1, 3),
  },
  content: {
    padding: theme.spacing(2, 3),
  },
  actions: {
    padding: theme.spacing(2, 3),
    gap: theme.spacing(1),
  },
  ticketInfo: {
    backgroundColor: theme.palette.grey[50],
    padding: theme.spacing(2),
    borderRadius: "8px",
    marginBottom: theme.spacing(2),
  },
  ticketTitle: {
    fontSize: "1rem",
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(0.5),
  },
  ticketDetails: {
    fontSize: "0.875rem",
    color: theme.palette.text.secondary,
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
}));

const TagsModal = ({ open, onClose, ticketId, ticket }) => {
  const classes = useStyles();
  const [tagModalOpen, setTagModalOpen] = useState(false);

  // ✅ Abrir TagModal cuando se abre TagsModal
  useEffect(() => {
    if (open) {
      setTagModalOpen(true);
    }
  }, [open]);

  const handleCloseTagModal = () => {
    setTagModalOpen(false);
    onClose(); // Cerrar también el TagsModal padre
  };

  const handleReload = () => {
    // ✅ Opcional: Recargar datos del ticket si es necesario
    // Por ahora no necesitamos hacer nada especial
  };

  return (
    <>
      {/* ✅ Modal principal - Solo para mostrar información del ticket */}
      <Dialog
        open={open && !tagModalOpen}
        onClose={onClose}
        className={classes.dialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle className={classes.title}>
          <span role="img" aria-label="Nueva Etiqueta">🏷️</span> Nueva Etiqueta
        </DialogTitle>
        
        <DialogContent className={classes.content}>
          {/* ✅ Información del Ticket */}
          {ticket && (
            <Box className={classes.ticketInfo}>
              <Typography className={classes.ticketTitle}>
                Ticket #{ticket.id}
              </Typography>
              <Typography className={classes.ticketDetails}>
                Contacto: {ticket.contact?.name}
              </Typography>
              <Typography className={classes.ticketDetails}>
                Estado: {ticket.status}
              </Typography>
            </Box>
          )}

          <Divider className={classes.divider} />

          <Typography variant="body1" style={{ textAlign: 'center', padding: '20px' }}>
            Haz clic en "Crear Etiqueta" para abrir el formulario de nueva etiqueta.
          </Typography>
        </DialogContent>

        <DialogActions className={classes.actions}>
          <Button
            onClick={onClose}
            variant="outlined"
            color="secondary"
          >
            Cancelar
          </Button>
          <Button
            onClick={() => setTagModalOpen(true)}
            variant="contained"
            color="primary"
          >
            Crear Etiqueta
          </Button>
        </DialogActions>
      </Dialog>

      {/* ✅ TagModal - El formulario real de creación de etiquetas */}
      <TagModal
        open={tagModalOpen}
        onClose={handleCloseTagModal}
        reload={handleReload}
        tagId={null} // Siempre crear nueva etiqueta
      />
    </>
  );
};

export default TagsModal;
